import { ref, watch } from 'vue'

/**
 * Composable to synchronize query parameters.
 * Only intended for pages not using Vue Router
 */
export default function useCurrentURL(url: string = window.location.href) {
  const urlRef = ref<string>(url)
  const query = ref<Record<string, string>>(Object.fromEntries(new URLSearchParams(new URL(url).search)))

  watch(
    () => query,
    () => {
      const url = new URL(urlRef.value)
      url.search = new URLSearchParams(Object.entries(query.value)).toString()
      window.history.replaceState({}, '', url)
    },
    { deep: true },
  )

  return {
    url: urlRef,
    query,
  }
}
